import { render, staticRenderFns } from "./IconCoins.vue?vue&type=template&id=36d51933&functional=true&"
import script from "./IconCoins.vue?vue&type=script&lang=js&"
export * from "./IconCoins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports